<form [formGroup]="jobOfferForm">
    <div class="main-create-job-offer">
        <div id="content" class="main-content" role="main"> 
            
            <div class="step-indicator hideInMobile" *ngIf="status === 0">
                <div class="step initial-step" [class.active]="step >= 1" >{{ 'createJobOffer.step1.steps.step1' | translate }}</div>
                <div class="step" [class.active]="step >= 2" >{{ 'createJobOffer.step1.steps.step2' | translate }}</div>
                <div class="step final-step" [class.active]="step >= 3" >{{ 'createJobOffer.step1.steps.step3' | translate }}</div>
            </div>

            <div class="step-indicator hideInMobile" *ngIf="status === 1">
                <div class="step initial-step" [class.active]="true" (click)="goToStep(1)">{{ 'createJobOffer.step1.steps.step1' | translate }}</div>
                <div class="step" [class.active]="true" (click)="goToStep(2)">{{ 'createJobOffer.step1.steps.step2' | translate }}</div>
                <div class="step final-step" [class.active]="true" (click)="goToStep(3)">{{ 'createJobOffer.step1.steps.step3' | translate }}</div>
            </div>
    
            <div class="step-indicator hideInDesktop" *ngIf="status === 0">
                <div class="step initial-step" [class.active]="step >= 1">{{ 'createJobOffer.step1.steps.step' | translate }} 1</div>
                <div class="step" [class.active]="step >= 2">{{ 'createJobOffer.step1.steps.step' | translate }} 2</div>
                <div class="step final-step" [class.active]="step >= 3">{{ 'createJobOffer.step1.steps.step' | translate }} 3</div>
            </div>

            <div class="step-indicator hideInDesktop" *ngIf="status === 1">
                <div class="step initial-step" [class.active]="true" (click)="goToStep(1)">{{ 'createJobOffer.step1.steps.step' | translate }} 1</div>
                <div class="step" [class.active]="true" (click)="goToStep(2)">{{ 'createJobOffer.step1.steps.step' | translate }} 2</div>
                <div class="step final-step" [class.active]="true" (click)="goToStep(3)">{{ 'createJobOffer.step1.steps.step' | translate }} 3</div>
            </div>

            <h2>{{ 'createJobOffer.step1.title' | translate }}</h2>
            <p [innerHTML]="'createJobOffer.step1.description' | translate"></p>
            <div class="message-saved" *ngIf="message_saved">
                <p>{{message_saved}}</p>
            </div>
                <section>
                    <h4>{{ 'createJobOffer.step1.specialtyArea.title' | translate }}</h4>

                    <div class="row hideInMobileDiv" style="padding-top: 20px;" > 
                        <button  *ngFor="let category of generalCategories"
                        style="padding: 12px; margin: 6px; font-size: 14px !important;"
                        type="button"
                        (click)="addcategory(category)"
                        [ngClass]="{'selected_chip': jobOfferForm.get('specialty_area')?.value === category.name, 'unselected_chip': !(jobOfferForm.get('specialty_area')?.value === category.name)}"
                        >{{ 'specialtyArea.' + category.name | translate }}</button>
                    </div>

                    <div class="row2 hideInDesktopDiv">
                        <div class="column2">
                            <mat-form-field appearance="fill" style="width: 100%;">
                                <mat-select [placeholder]="'createJobOffer.step1.specialtyArea.placeholder' | translate" formControlName="specialty_area" >
                                    <mat-option [value]="category.name" *ngFor="let category of generalCategories">{{ 'specialtyArea.' + category.name | translate }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div *ngIf="jobOfferForm.get('specialty_area')?.hasError('required') && jobOfferForm.get('idioms')?.touched" class="formError">
                        <p>
                            {{ 'createJobOffer.step1.specialtyArea.error' | translate }}
                        </p>
                    </div>

                    <div class="row2" *ngIf="jobOfferForm.get('specialty_area')?.value">
                        <div class="column2">
                            <h4>{{ 'createJobOffer.step1.roleName.title' | translate }}</h4>
                            <mat-form-field appearance="fill" style="width: 100%;">
                                <mat-label>{{ 'createJobOffer.step1.roleName.label' | translate }}</mat-label>
                                <input matInput formControlName="role_name">
                            </mat-form-field>
                            <div *ngIf="jobOfferForm.get('role_name')?.hasError('required') && jobOfferForm.get('role_name')?.touched" class="formError">
                                <p>
                                    {{ 'createJobOffer.step1.roleName.error' | translate }}
                                </p>
                            </div>
                            

                        </div>
                        <div class="column2">
                            <h4>{{ 'createJobOffer.step1.seniority.title' | translate }}</h4>
                            <mat-form-field appearance="fill" style="width: 100%;">
                                <mat-label>{{ 'createJobOffer.step1.seniority.label' | translate }}</mat-label>
                                <mat-select formControlName="role_seniority" >
                                    <mat-option [value]="'junior'">{{ 'createJobOffer.step1.seniority.junior' | translate }}</mat-option>
                                    <mat-option [value]="'mid'">{{ 'createJobOffer.step1.seniority.mid' | translate }}</mat-option>
                                    <mat-option [value]="'senior'">{{ 'createJobOffer.step1.seniority.senior' | translate }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <div *ngIf="jobOfferForm.get('role_seniority')?.hasError('required') && jobOfferForm.get('role_seniority')?.touched" class="formError">
                                <p>
                                    {{ 'createJobOffer.step1.seniority.error' | translate }}
                                </p>
                            </div>
                        </div>

                    </div>
                </section>

                <section>
                    <h4>{{ 'createJobOffer.step1.languages.title' | translate }}</h4>

                    <p [innerHTML]="'createJobOffer.step1.languages.description' | translate"></p>

                    <div class="row2">
                        <div class="column2">
                            <mat-form-field appearance="fill" style="width: 100%;">
                                <mat-label>{{ 'createJobOffer.step1.languages.selectLanguage' | translate }}</mat-label>
                                <mat-select formControlName="idioms" >
                                    <mat-option *ngFor="let lang of languages" [value]="lang.id">
                                        {{ lang.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="column2">
                            <mat-form-field appearance="fill" style="width: 100%;">
                                <mat-label>{{ 'createJobOffer.step1.languages.selectLevel' | translate }}</mat-label>
                                <mat-select formControlName="idiomslevel" >
                                    <mat-option [value]="'basic'">{{ 'createJobOffer.step1.languages.basic' | translate }}</mat-option>
                                    <mat-option [value]="'advanced'">{{ 'createJobOffer.step1.languages.advanced' | translate }}</mat-option>
                                    <mat-option [value]="'native'">{{ 'createJobOffer.step1.languages.native' | translate }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="addEducation" (click)="addidiom()" id = "addidiom">
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.3337 7.33463H12.667V12.668H7.33366V15.3346H12.667V20.668H15.3337V15.3346H20.667V12.668H15.3337V7.33463ZM14.0003 0.667969C6.64033 0.667969 0.666992 6.6413 0.666992 14.0013C0.666992 21.3613 6.64033 27.3346 14.0003 27.3346C21.3603 27.3346 27.3337 21.3613 27.3337 14.0013C27.3337 6.6413 21.3603 0.667969 14.0003 0.667969ZM14.0003 24.668C8.12033 24.668 3.33366 19.8813 3.33366 14.0013C3.33366 8.1213 8.12033 3.33464 14.0003 3.33464C19.8803 3.33464 24.667 8.1213 24.667 14.0013C24.667 19.8813 19.8803 24.668 14.0003 24.668Z" fill="#7712E3"/>
                        </svg>
                        {{ 'createJobOffer.step1.languages.addLanguages' | translate }}
                    </div>

                    <div class="row2" *ngIf="selected_idioms.length > 0" style="margin-top: 30px; justify-content: flex-start; text-align: left;">
                        <div *ngFor="let idiom_tuple of selected_idioms" style="margin-right: 20px; margin-bottom: 10px;">
                            <p style="color: #2B343C;">{{get_lang(idiom_tuple.id)}} - {{idiom_tuple.proficiency}} <img src="assets/trash.png" style="width: 20px; height: 20px; margin-left: 10px; vertical-align: middle;" (click)="deleteidiom(idiom_tuple)"></p>
                        </div>
                    </div>
                    <div class="formError" *ngIf="languagesError">
                        <p>
                            {{ 'createJobOffer.step1.languages.error' | translate }}
                        </p>
                    </div>

                </section>

                <section>
                    <h4>{{ 'createJobOffer.step1.location.title' | translate }}</h4>
                    <p [innerHTML]="'createJobOffer.step1.location.description' | translate"></p>
                    <div class="row2">
                        <div class="column2">
                            <mat-form-field appearance="fill" class="width-variable" >
                                <mat-label>{{ 'createJobOffer.step1.location.label' | translate }}</mat-label>
                                <input matInput formControlName="location">
                            </mat-form-field>
                        </div>
                    </div>
                    <div *ngIf="jobOfferForm.get('location')?.hasError('required') && jobOfferForm.get('location')?.touched" class="formError">
                        <p>{{ 'createJobOffer.step1.location.error' | translate }}</p>
                    </div>
                    <div class="row" style="margin-bottom:10px;margin-top:20px;">
                        <span style="font-weight: 500;margin-top:20px;">{{ 'createJobOffer.step1.location.remoteDays' | translate }}</span>
                    </div>
                    <div class="row2">
                        <div class="column2" style="margin-left: 10px;">
                            <div class="slider-container">
                                <mat-slider
                                  min="0"
                                  max="5"
                                  step="1"
                                  value="5"
                                  thumbLabel="true"
                                  tickInterval="1"
                                  class="custom-slider"
                                  color="primary">
                                  <input matSliderThumb value="0" formControlName="remote_days">
                                </mat-slider>
                                <div class="labels">
                                    <span class="tick" style="left: 0%">0</span>
                                    <span class="tick" style="left: 20%">1</span>
                                    <span class="tick" style="left: 40%">2</span>
                                    <span class="tick" style="left: 60%">3</span>
                                    <span class="tick" style="left: 80%">4</span>
                                    <span class="full-remote" style="left: 100%;">5 <br> {{ 'createJobOffer.step1.location.fullRemote' | translate }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                
                <section style="margin-top: 110px;">
                    <h4>{{ 'createJobOffer.step1.similarProfiles.title' | translate }}</h4>
                    <p [innerHTML]="'createJobOffer.step1.similarProfiles.description' | translate"></p>
                    
                    <div class="row2">
                        <div class="column2">
                            <mat-form-field appearance="fill" style="width: 100%;">
                                <mat-label>{{ 'createJobOffer.step1.similarProfiles.label' | translate }}</mat-label>
                                <input matInput formControlName="similar_profiles" (keyup)="addsimilarprofilebycomma($event)">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="addEducation" (click)="addsimilarprofile()" id = "addsimilarprofile">
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.3337 7.33463H12.667V12.668H7.33366V15.3346H12.667V20.668H15.3337V15.3346H20.667V12.668H15.3337V7.33463ZM14.0003 0.667969C6.64033 0.667969 0.666992 6.6413 0.666992 14.0013C0.666992 21.3613 6.64033 27.3346 14.0003 27.3346C21.3603 27.3346 27.3337 21.3613 27.3337 14.0013C27.3337 6.6413 21.3603 0.667969 14.0003 0.667969ZM14.0003 24.668C8.12033 24.668 3.33366 19.8813 3.33366 14.0013C3.33366 8.1213 8.12033 3.33464 14.0003 3.33464C19.8803 3.33464 24.667 8.1213 24.667 14.0013C24.667 19.8813 19.8803 24.668 14.0003 24.668Z" fill="#7712E3"/>
                        </svg>
                        {{ 'createJobOffer.step1.similarProfiles.addProfile' | translate }}
                    </div>
                    <div class="row2" *ngIf="selected_similar_profiles.length > 0" style="margin-top: 30px; justify-content: flex-start; text-align: left;">
                        <div *ngFor="let similar_profile of selected_similar_profiles" style="margin-right: 20px; margin-bottom: 10px;">
                            <p style="color: #2B343C; word-break: break-all; white-space: normal;">
                                {{similar_profile}}
                                <img src="assets/trash.png" alt="Eliminar perfil" style="width: 20px; height: 20px; margin-left: 10px; vertical-align: middle;" (click)="deletesimilarprofile(similar_profile)">
                            </p>
                        </div>
                    </div>
                </section>

                <section style="margin-top: 80px;">
                    <h4>{{ 'createJobOffer.step1.salaryRange.title' | translate }}</h4>
                    <p [innerHTML]="'createJobOffer.step1.salaryRange.description' | translate"></p>


                    <div class="row2">
                        <div class="column2">
                            <h4>{{ 'createJobOffer.step1.salaryRange.minSalary.title' | translate }}</h4>
                            <mat-form-field appearance="fill"  style="width: 100%;">
                                <mat-label>{{ 'createJobOffer.step1.salaryRange.minSalary.label' | translate }}</mat-label>
                                <input matInput formControlName="min_salary" type="number" >
                                
                            </mat-form-field>
                            <div class="formError" *ngIf="jobOfferForm.get('min_salary')?.hasError('min') && jobOfferForm.get('min_salary')?.touched">
                                <p>{{ 'createJobOffer.step1.salaryRange.minSalary.errorMin' | translate }}</p>
                            </div>
                            <div class="formError" *ngIf="jobOfferForm.get('min_salary')?.hasError('required') && jobOfferForm.get('min_salary')?.touched">
                                <p>
                                    {{ 'createJobOffer.step1.salaryRange.minSalary.errorRequired' | translate }}
                                </p>
                            </div>

                        </div>
                        <div class="column2">
                            <h4>{{ 'createJobOffer.step1.salaryRange.maxSalary.title' | translate }}</h4>
                            <mat-form-field appearance="fill"  style="width: 100%;">
                                <mat-label>{{ 'createJobOffer.step1.salaryRange.maxSalary.label' | translate }}</mat-label>
                                <input matInput formControlName="max_salary" type="number">
                            </mat-form-field>
                            <div class="formError" *ngIf="jobOfferForm.get('max_salary')?.hasError('min') && jobOfferForm.get('max_salary')?.touched && jobOfferForm.get('min_salary')?.value">
                                <p>{{ 'createJobOffer.step1.salaryRange.maxSalary.errorMin' | translate }}</p>
                            </div>
                            <div class="formError" *ngIf="jobOfferForm.get('min_salary')?.hasError('required') && jobOfferForm.get('min_salary')?.touched && jobOfferForm.get('max_salary')?.value">
                                <p>
                                    {{ 'createJobOffer.step1.salaryRange.maxSalary.errorRequired' | translate }}
                                </p>
                            </div>
                            <div *ngIf="jobOfferForm.get('max_salary')?.value < jobOfferForm.get('min_salary')?.value && jobOfferForm.get('max_salary')?.touched && jobOfferForm.get('max_salary')?.value && jobOfferForm.get('min_salary')?.value" class="formError">
                                <p>{{ 'createJobOffer.step1.salaryRange.maxSalary.errorLessThanMin' | translate }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="row2" style="margin-top: 3%;">
                        <div class="column2">
                            <h4>{{ 'createJobOffer.step1.salaryRange.benefits.title' | translate }}</h4>
                            <mat-form-field appearance="fill" style="width: 100%;">
                                <mat-label>{{ 'createJobOffer.step1.salaryRange.benefits.placeholder' | translate }}</mat-label>
                                <input matInput formControlName="benefits">
                            </mat-form-field>
                        </div>
                        <div class="column2">

                        </div>
                    </div>
                </section>

                <section class="section-margin-variable-description">
                    <h4>{{ 'createJobOffer.step1.jobDescription.title' | translate }}</h4>
                    <p>{{ 'createJobOffer.step1.jobDescription.description' | translate }}</p>
                    <!-- Hidden file input -->
                     <div style = "display:flex; cursor:pointer;margin-top:20px;" (click)="triggerFileInput()">
                        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style = "margin-right:10px;">
                            <g id="upload-cloud-01">
                            <path id="Icon" d="M4 16.2422C2.79401 15.435 2 14.0602 2 12.5C2 10.1564 3.79151 8.23129 6.07974 8.01937C6.54781 5.17213 9.02024 3 12 3C14.9798 3 17.4522 5.17213 17.9203 8.01937C20.2085 8.23129 22 10.1564 22 12.5C22 14.0602 21.206 15.435 20 16.2422M8 16L12 12M12 12L16 16M12 12V21" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </g>
                        </svg>
                        <span>{{ 'createJobOffer.step1.jobDescription.uploadFile' | translate }}</span>
                        <span *ngIf="selectedFileName" class = "file-name">{{selectedFileName}}</span>
                     </div>
                        
                    <input #fileInput type="file" style="display: none;" (change)="onFileSelected($event)">

                    <p style = "margin-top:15px;">{{ 'createJobOffer.step1.jobDescription.optionalDescription' | translate }}</p>
                    <quill-editor style="height: 200px; width:100%" formControlName="textual_description"></quill-editor>

                </section>
            </div>
        </div>

        <div class="actions two-actions" style="margin-top: 10%; padding-bottom: 3%; margin-bottom: 10%;">
            <div class = "actions-left">
                
            </div>
            <div class = "actions-right">
                <button mat-raised-button color="primary" type="button"  class = "light-button" style="margin-right: 15px;" (click)="save_progress()">
                    <span  *ngIf="!loading">{{ 'createJobOffer.step1.actions.saveProgress' | translate }}</span>
                    <div style = "height:30px;" *ngIf="loading"><img class = "loading-button" src="/assets/spinner.gif" [alt]="'createJobOffer.step1.actions.loading' | translate"></div>
                 </button>
                <button mat-raised-button color="primary" type="button" class = "linkedin-button" (click)="nextStep()">
                    <span  *ngIf="!loading">{{ 'createJobOffer.step1.actions.completeAndContinue' | translate }}</span>
                    <div style = "height:30px;" *ngIf="loading"><img class = "loading-button" src="/assets/spinner.gif" [alt]="'createJobOffer.step1.actions.loading' | translate"></div>
                </button>
                

            </div>
            
        </div>


    </form>